import React, { Component } from "react";
// @material-ui/core components
import Chip from '@material-ui/core/Chip';
import InputLabel from '@material-ui/core/InputLabel';
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import CardFooter from "components/Card/CardFooter.js";
import Button from "components/CustomButtons/Button.js";
import CustomSelect from "components/CustomSelect/CustomSelect.js";
// services
import activityService from "services/activity.service";
// util
import Notifications from "views/Notifications/Notifications";


class DragAndDrop extends Component {
    
    constructor(props) {
        super(props);
        if(this.props.activity){
            let wrongOptions = this.props.activity.wrongOptions.reduce((accumulator, currentValue) => `${accumulator} ${currentValue}`)
            this.state = {units: this.props.unity, unity: this.props.activity.unity, title: this.props.activity.title, sentence: this.props.activity.sentence, words: wrongOptions, chipWords: [], notification: {show: false, message: '', type: 'info'}};
            this.updateChip();
        } else {
            this.state = {units: this.props.unity, unity: '', title: '', sentence: '', words: '', chipWords: [], notification: {show: false, message: '', type: 'info'}};
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange = (event) => {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value,
        });

        this.updateChip();
    };

    handleSubmit() {
        let correctOptions = [];
        let wrongOptions = [];
    
        this.state.chipWords.forEach(words => {
            if(words.color === 'primary') correctOptions.push(words.word)
            if(words.color === 'secondary') wrongOptions.push(words.word)
        })

        if(!this.props.activity){
            activityService.createActivity({type: 'draganddrop', unity: this.state.unity, title: this.state.title, sentence: this.state.sentence, correctOptions: correctOptions, wrongOptions: wrongOptions})
            .then(res => this.showNotification('Atividade cadastrada com sucesso!', 'success'))
            .catch(err => this.showNotification('Ocorreu um erro ao tentar cadastrar atividade! ' + err, 'danger'))
        } else {
            this.handleEdit(correctOptions, wrongOptions);
        }
    }

    handleEdit(correctOptions, wrongOptions) {
        activityService.updateActivity(this.props.activity.id, {unity: this.state.unity, title: this.state.title, sentence: this.state.sentence, correctOptions: correctOptions, wrongOptions: wrongOptions})
        .then(res => this.showNotification('Atividade atualizada com sucesso!', 'success'))
        .catch(err => this.showNotification('Ocorreu um erro ao tentar atualizar atividade! ' + err, 'danger'))
    }

    showNotification(message, type){
        this.setState({notification: {show: true, message: message, type: type}});
        setTimeout(() => {
            this.setState({notification: {show: false, message: '', type: 'info'}});
            this.props.onClose()
        }, 3000);
    }

    async updateChip() {
        const chips = [];

        await this.state.sentence.split('*').forEach((word, i) => {
            if(i % 2 !== 0) chips.push({word: word, color: 'primary'})
        })

        await this.state.words.split(' ').forEach(word => {
            if(word !== '') chips.push({word: word, color: 'secondary'})
        })

        this.setState({chipWords: chips})
    }

    render (){
        return(
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <CustomSelect
                    labelText="Unidade" 
                    id="unity"
                    formControlProps={{
                        fullWidth: true
                    }}
                    inputProps={{
                        type: "text",
                        name: "unity",
                        value:this.state.unity,
                        onChange:this.handleChange
                    }}
                    selectItems={this.state.units}
                    />
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                    <CustomInput 
                        labelText="Título da atividade" 
                        id="title"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            type: "text",
                            name: "title",
                            value:this.state.title,
                            onChange:this.handleChange
                        }}
                    />  
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                    <CustomInput 
                        labelText="Frase completa" 
                        id="sentence"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            type: "text",
                            name: "sentence",
                            value:this.state.sentence,
                            onChange:this.handleChange
                        }}
                    />  
                    <InputLabel id="label">Adicione dois asteriscos entre as palavras que deverão ser completadas. *exemplo*</InputLabel>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                    <CustomInput 
                        labelText="Opções de palavras" 
                        id="words"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            type: "text",
                            name: "words",
                            value:this.state.words,
                            onChange:this.handleChange
                        }}
                    />  
                    <InputLabel id="label">Informe as palavras separadas por espaço, sem virgulas</InputLabel>
                </GridItem>
                <GridItem xs={12} sm={12} md={12} style={{marginTop: 20}}>
                    {
                        this.state.chipWords.map((chip, i) => {
                            return (<Chip label={chip.word} color={chip.color} variant="outlined" key={i} />)
                        })
                    }
                </GridItem>
                <CardFooter>
                    <Button color="primary" type="submit" round onClick={this.handleSubmit}>{(!this.props.activity ? 'Cadastrar' : 'Editar')}</Button>
                </CardFooter>
                {(this.state.notification.show === true) ? (<Notifications notification={this.state.notification} />) : null}
            </GridContainer>
        )
    }
}

export default (DragAndDrop);